import React from 'react';
import '../css/ClassificationSocietiesPage.css';

/**
 * ClassificationCard – one alternating society row.
 *
 * Props:
 *  name        {string}   – society name
 *  logo        {string}   – logo image path
 *  address     {string[]} – address lines
 *  officeInfo  {object}   – { tel, tel2, fax, mobile, email, email2, web, webLabel }
 *  person      {object}   – { name, title, mobile, email }
 *  reverse     {bool}     – if true: logo LEFT | info RIGHT
 */
const ClassificationCard = ({ name, logo, address, officeInfo, person, reverse, index }) => {
  const delay = index * 100;

  const InfoPanel = (
    <div
      className="cs-dark"
      data-aos={reverse ? "fade-left" : "fade-right"}
      data-aos-delay={delay}
    >
      <h3><strong>{name}</strong></h3>

      <div className="cs-inner-grid">
        {/* Address column */}
        <div className="cs-inner-col">
          {address.map((line, i) => <p key={i}>{line}</p>)}
        </div>

        {/* Contact column */}
        <div className="cs-inner-col">
          {officeInfo.tel  && <p>Tel : <a href={`tel:${officeInfo.tel}`}>{officeInfo.tel}</a></p>}
          {officeInfo.tel2 && <p>Tel : <a href={`tel:${officeInfo.tel2}`}>{officeInfo.tel2}</a></p>}
          {officeInfo.fax  && <p>Fax : <a href={`fax:${officeInfo.fax}`}>{officeInfo.fax}</a></p>}
          {officeInfo.mobile && <p>Mobile : <a href={`tel:${officeInfo.mobile}`}>{officeInfo.mobile}</a></p>}
          {officeInfo.email  && <p>Email : <a href={`mailto:${officeInfo.email}`}>{officeInfo.email}</a></p>}
          {officeInfo.email2 && <p><a href={`mailto:${officeInfo.email2}`}>{officeInfo.email2}</a></p>}
          {officeInfo.web    && <p>Web : <a href={officeInfo.web} target="_blank" rel="noopener noreferrer">{officeInfo.webLabel || officeInfo.web}</a></p>}
        </div>
      </div>

      {/* Contact person */}
      {person && (
        <>
          <hr className="cs-person-divider" />
          <div className="cs-inner-grid">
            <div className="cs-inner-col">
              <p className="cs-person-name">{person.name}</p>
              <p className="cs-person-title">{person.title}</p>
            </div>
            <div className="cs-inner-col">
              {person.mobile && <p>Mobile : <a href={`tel:${person.mobile}`}>{person.mobile}</a></p>}
              {person.tel    && <p>Tel : <a href={`tel:${person.tel}`}>{person.tel}</a></p>}
              {person.mobile2 && <p><a href={`tel:${person.mobile2}`}>{person.mobile2}</a></p>}
              {person.email  && <p>Email : <a href={`mailto:${person.email}`}>{person.email}</a></p>}
            </div>
          </div>
        </>
      )}
    </div>
  );

  const LogoPanel = (
    <div
      className="cs-light"
      data-aos={reverse ? "fade-right" : "fade-left"}
      data-aos-delay={delay}
    >
      <img src={logo} alt={name} className="cs-logo" loading="lazy" />
    </div>
  );

  return (
    <div className={`cs-row${reverse ? ' cs-reverse' : ''}`}>
      {reverse ? <>{LogoPanel}{InfoPanel}</> : <>{InfoPanel}{LogoPanel}</>}
    </div>
  );
};

export default ClassificationCard;
